import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { clearLocalStorage } from '@app-helpers/functions';
import { SignupService } from '@app-services/signup/signup.service';
import { UserService } from '@app-services/user/user.service';
import { ErrorDialogComponent } from '@app-shared/components/error-dialog/error-dialog.component';
import { openDefaultLoginDialog } from '../home/home.component';

export function openMessageDialog(): void {
  const config: MatDialogConfig = {
    // width: '450px',
    width: '500px',
    data: { msg: `Seems like you are not registerd teacher.` }
     
  };
  const dialogRef = this.dialog.open(ErrorDialogComponent, config);
  dialogRef.afterClosed().subscribe((value) => {});
}

@Component({
  selector: 'app-teacher-home',
  templateUrl: './teacher-home.component.html',
  styleUrls: ['./teacher-home.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class TeacherHomeComponent implements OnInit {
  openMessageDialog = openMessageDialog;
  openOTPLoginDialog = openDefaultLoginDialog;
  searchValue: any = '';
  userTypeId: any = 1;
  constructor(private dialog: MatDialog, public signUpService: SignupService, private userService: UserService, private router: Router) { }

  ngOnInit(): void {
    this.userTypeId = this.userService.getUserType();
    if(this.userTypeId == 2){
      this.router.navigate(['/dashboard/liveclass'])
    }
  }

  doSearch(value: string): void {
    this.searchValue = value;
  }

  enterKey(event: any, num: any): void {

    // console.log(this.searchValue.number.length)
    if (event.keyCode == 13 && event.target.value.length === 10) {
      // this.signup(num);
    }
  }

  escapeKey(event: any) {
    event.target.value = '';
  }

  signup(num: any) {
    this.clearLocalStorage();
    this.signUpService.verifyPhoneNumber(this.searchValue).subscribe((data) => {
      if (data.existingUser === false) {
        this.openMessageDialog();
      } else if (data.existingUser === true) {
        this.openOTPLoginDialog(this.searchValue);
      }
  });
}

  clearLocalStorage(): void {
    clearLocalStorage();
  }

}
